import { isAxiosError } from 'axios';
/**
 * The deployment lookup succeeded but listed nothing for this user — either no agent is assigned
 * to the capability, or one is but the user can't see it (for example, it lives in a project the
 * user isn't a member of). Distinct from a request failure so the UI doesn't send the user to check
 * configuration when the network or their session is the problem.
 */
export class DeploymentNotAvailableError extends Error {
    deploymentType;
    constructor(deploymentType) {
        super(`No ${deploymentType} deployment found`);
        this.name = 'DeploymentNotAvailableError';
        this.deploymentType = deploymentType;
    }
}
export function classifyChatInitError(error) {
    if (error instanceof DeploymentNotAvailableError) {
        return 'not-available';
    }
    if (isAxiosError(error)) {
        // No response: the request never completed (offline, DNS, CORS, proxy, timeout).
        if (!error.response) {
            return 'network';
        }
        if (error.response.status === 401 || error.response.status === 403) {
            return 'auth';
        }
    }
    return 'unknown';
}
export function getChatInitErrorMessage(kind, host) {
    switch (kind) {
        case 'not-available':
            return (`No ${host} chat agent is available to your account. Ask your Airia administrator ` +
                `to check that an agent is assigned to ${host} Chat under Settings → Extensions ` +
                "and that it's shared with you (for example, through its project).");
        case 'network':
            return "Couldn't reach Airia. Check your network connection and try again.";
        case 'auth':
            return ("Your session has expired or your account isn't allowed to use this add-in. " +
                'Sign in again, or contact your Airia administrator if the problem continues.');
        default:
            return ('Failed to initialize chat service. Please try again. If the problem continues, ' +
                'contact your Airia administrator.');
    }
}
